import { render } from "./SelectFee.vue?vue&type=template&id=0159c50d"
import script from "./SelectFee.vue?vue&type=script&lang=js"
export * from "./SelectFee.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__